import type { HashRequest, HashResponse } from "./types";

const BASE_URL = process.env.NEXT_PUBLIC_PULSE_HASHER_URL;

async function fetchPPID3Hashes(
  hashRequestBody: HashRequest,
): Promise<HashResponse | null> {
  if (!BASE_URL) {
    console.warn("Pulse hasher URL is not defined");
    return null;
  }

  try {
    const response = await fetch(`${BASE_URL}/api/v1/hash`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(hashRequestBody),
    });

    if (!response.ok) {
      console.error(
        `Failed to fetch PPID3 hashes: ${response.status} ${response.statusText}`,
      );

      return null;
    }

    const responseData = await response.json();
    return responseData || null;
  } catch (error) {
    console.error("Error fetching PPID3 hashes:", error);
    return null;
  }
}

export { fetchPPID3Hashes };
